var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-result',{attrs:{"title":_vm.title,"sub-title":_vm.subTitle,"icon":_vm.icon}},[(_vm.showButton)?_c('div',{attrs:{"slot":"extra"},slot:"extra"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":_vm.buttonClick}},[_vm._v(_vm._s(_vm.buttonText))])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }